import { Center } from "@chakra-ui/react";

export default function NotFound() {
  return <Center minH="100vh">404</Center>;
}
